import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import { changeProductFilter } from '../actions';

const Container = styled.div``;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class ProductSearchStatusComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE }, this.doSearch);
  }

  get options() {
    return [{ label: this.lbl(`invoice.subject.status.all`), value: null }].concat(
      [
        { label: 'active', value: '0' },
        { label: 'de-active', value: '1' },
        { label: 'deleted', value: '2' },
      ].map(option => ({
        label: this.lbl(`product.column.type.${option.label}`),
        value: option.value,
      })),
    );
  }

  get value() {
    return this.options.find(o => o.value == this.props.filter.type);
  }

  render() {
    return (
      <Container>
        <SearchSelect
          options={this.options}
          value={this.value}
          onChange={pair => this.props.setValue('status', pair.value)}
        />
      </Container>
    );
  }
}

ProductSearchStatusComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(type, string) {
      dispatch(changeProductFilter(type, string));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductSearchStatus = compose(withConnect, withRouter, injectIntl)(ProductSearchStatusComp);
